<template>
  <div class="wrapper">
    <div class="container">
      <md-card class="customCard navbar-margin">
        <md-card-content>
          <div class="tim-typo">
            <h2 class="title">Renofloor Böden</h2> 
            <p>Aus alt mach' neu! Das bessere Belagsystem für innen und außen. RENOfloor Böden bieten im Außenbereich eine witterungs- und frostbeständige Lösung, optimal für Ihre Terrasse, den Balkon, die Treppe oder den Gartenweg.<br> 
              Pflegeleicht, lösungsmittelfrei, naturnah und hygienisch einwandfrei, so profitiert auch Ihr Wohnbereich.</p>
          </div>
          <div class="gallery">
            <div class="gallery-panel"
              v-for="image in images"
              :key="image.id">
              <mdb-view  class="rounded z-depth-1-half" :src=image.pathLong alt="">
                <mdb-mask flex-center >
                  <p class="panel-titel"> {{image.fileName[0]}} </p>
                </mdb-mask>
              </mdb-view>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>


import { mdbView, mdbMask } from "mdbvue";

export default {
  name: 'Gallery',
  data() {
    return {
      images: [],
    };
  },
  mounted() {
    //declare the folder path to the product image folder here
    this.importAll(require.context('../assets/prod_images/Renofloor/', true, /\.(jpg|png|gif)$/));
  },
  methods: {
    importAll(r) {
      r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key, fileName: key.match(/[ \w-ÄäÖöÜüß]+?(?=\.)/) })));
    },
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  components: {
    mdbView,
    mdbMask
  }
};
</script>